import React from "react";
import { useTheme } from "@mui/material/styles";
import MobileStepper from "@mui/material/MobileStepper";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

const MobileStepperFooter = ({
  steps,
  activeStep,
  disabledPrevious,
  disabledNext,
  handlePrevious,
  handleNext,
  previousText,
  nextText,
  hidePrevious = true
}) => {
  const theme = useTheme();
  return (
    <MobileStepper
      variant="progress"
      steps={steps}
      position="static"
      activeStep={activeStep}
      sx={{ flexGrow: 1, '& .MuiLinearProgress-root' : hidePrevious ? { width: '90%' } : {} }}
      nextButton={
        <Button size="small" onClick={handleNext} disabled={disabledNext}>
          {nextText}
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </Button>
      }
      backButton={
        !hidePrevious ? 
        <Button
          size="small"
          onClick={handlePrevious}
          disabled={disabledPrevious}
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
          {previousText}
        </Button>
        : null
      }
    />
  );
};

export default MobileStepperFooter;
